export default __webpack_public_path__ + "static/media/m-serviceInfo2.cb0d4f7a.png";